import { z } from 'zod'

export const materialSchema = z.object({
  id: z.string().min(1),
  name: z.string().trim().min(1, 'Enter a material name.').max(160),
  quantity: z.number().finite().positive('Quantity must be greater than zero.').max(1000000),
  cost: z.number().finite().min(0).max(100000000).optional(),
  supplier: z.string().trim().max(160).optional(),
})
export type JobMaterial = z.infer<typeof materialSchema>
export const materialKey = (workspace: string, user: string, job: string) =>
  `job-materials.v1:${JSON.stringify([workspace, user, job])}`
export function readMaterials(key: string): JobMaterial[] {
  const raw = localStorage.getItem(key)
  return raw === null ? [] : z.array(materialSchema).parse(JSON.parse(raw))
}
export function appendMaterial(key: string, material: JobMaterial): JobMaterial[] {
  // Re-read before append so another mounted job view does not lose entries.
  const next = [...readMaterials(key), materialSchema.parse(material)]
  localStorage.setItem(key, JSON.stringify(next))
  window.dispatchEvent(new Event('job-materials-updated'))
  return next
}
